import { Box, SelectChangeEvent } from '@mui/material';
import { useEffect, useState } from 'react';

import { SelectInput } from '@/components/common/select_input/SelectInput';

import RowWrap from '../common/IntakeRowWrap';

function IntakeInpatientCareCheck({
  inpatientCareProvided,
  onChange,
}: {
  inpatientCareProvided: boolean | null;
  onChange: (isCollege: boolean | null) => void;
}) {
  const [providesInpatientCare, setProvidesInpatientCare] = useState<boolean | null>(
    inpatientCareProvided
  );

  const handleIsInpatientCareChange = (newInpatientCareValue: boolean | null) => {
    onChange(newInpatientCareValue);
  };

  useEffect(() => {
    if (inpatientCareProvided !== providesInpatientCare) {
      setProvidesInpatientCare(inpatientCareProvided);
    }
  }, [inpatientCareProvided, providesInpatientCare]);

  return (
    <RowWrap>
      <Box width='100%'>
        <SelectInput
          id={'inpatient-care-select'}
          label={'Does your facility provide inpatient care?'}
          value={providesInpatientCare == null ? '' : providesInpatientCare === true ? 'yes' : 'no'}
          selectOptions={[
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' },
          ]}
          onChange={(e: SelectChangeEvent) => {
            e.preventDefault();
            e.stopPropagation();

            const booleanValue =
              e.target.value === 'yes' ? true : e.target.value === 'no' ? false : null;

            handleIsInpatientCareChange(booleanValue);
          }}
        />
      </Box>
    </RowWrap>
  );
}

export default IntakeInpatientCareCheck;
